import { ShiftProps } from "../interfacesProps/ShiftProps";
import React,{useContext} from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { ShiftService } from "../api/ShiftService";
import {
  ShiftRelatedConstants,
  ShiftRelatedStylingConstants,
} from "../util/ShiftConstants";
import { makeStyles } from "@material-ui/core/styles";
import { roleNameEnum, NotAvailableString } from "../util/Common";
import { UIRelatedConstants } from "../theme/Theme";
import { ShiftListContext } from "./ShiftListContext";
import { RBButton } from "./RBButton";
import { RBContext } from './RBContext';
import { JobListContext } from "./JobListContext";

interface RBJobLayoutButtonProps {
  job: any;
  rolename: string;
}

const useStyles = makeStyles({
  root: {
    minWidth: 475,
    marginLeft: -250,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  CardContent: {
    paddingTop: 8,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  button: {
  position: "relative", // 👈 required so spinner stays inside button
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 120, // keeps button width stable
  height: 40, // 👈 optional: fixes height if it's shrinking
  borderRadius: UIRelatedConstants.ButtonBorderRadius,
  borderWidth: 1,
  backgroundColor: "#FFF",
  "&:hover": {
    backgroundColor: "#CDCDCD",
  },
},

spinner: {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)", // ✅ better centering
},
});

export const RBJobLayoutButton: React.FC<RBJobLayoutButtonProps> = ({
  ...props
}) => {
  const { job, rolename } = props;
  //const shiftListContext = React.useContext(ShiftListContext);
  const { onAction, loadingShiftId } = React.useContext(JobListContext);

  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);
  //console.log("RBShiftLayoutButton ", onAction);

  const renderJobLayoutButtonForWorker = () => {
    console.log("props1",props)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = useStyles();
    const jobState = ShiftService.getStatusForJobAsWorker(job);
    console.log("jobState",jobState)
    let buttonText = NotAvailableString;
    let borderColor, isButtonVisible;
     const isLoading = loadingShiftId === job.id;
    
    switch (jobState) {
      case ShiftRelatedConstants.JobStateText.AwaitingHiring:
        buttonText = ShiftRelatedConstants.ShiftButtonText.WithdrawJob;
        borderColor = primaryColor;
        isButtonVisible = true;

        break;

          
      default:
        isButtonVisible = false;
      //console.log("shift status is default");
    }

    return (
      <div>
        {isButtonVisible && (
          <Button
            className={classes.button}
            variant="outlined"
            style={{
              borderColor: borderColor,
              color: borderColor,
              textTransform: "none",
            }}
            onClick={() => onAction(buttonText, job)}
          >
             {isLoading ? (
              <CircularProgress size={20} color="inherit" className={classes.spinner} />
            ) : (
              buttonText
            )}
          </Button>
        )}
      </div>
    );
  };

  const renderJobLayoutButtonForPharmacy = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = useStyles();
    const jobState = ShiftService.getStatusForJobAsPharmacy(job);
    let buttonText = NotAvailableString;
    let borderColor, isButtonVisible;
    const isLoading = loadingShiftId === job.id;
    switch (jobState) {
      case ShiftRelatedConstants.JobStateText.AwaitingHiring:
        if (job.flags.isEditable) {
          buttonText = ShiftRelatedConstants.ShiftButtonText.EditJob;
          borderColor = primaryColor;
          isButtonVisible = true;
        } else {
          buttonText = ShiftRelatedConstants.ShiftButtonText.ViewApplications;
          borderColor = primaryColor;
          isButtonVisible = true;
        }

        break;

      default:
        isButtonVisible = false;
    }
    return (
      <div>
        {isButtonVisible && (
          <Button
            className={classes.button}
            variant="outlined"
            style={{
              borderColor: borderColor,
              color: borderColor,
              textTransform: "none",
            }}
            onClick={() => onAction(buttonText, job)}
          >
            {isLoading ? (
              <CircularProgress size={20} color="inherit" className={classes.spinner} />
            ) : (
              buttonText
            )}
          </Button>
        )}
      </div>
    );
  };

  return (
    <div>
      {rolename === roleNameEnum.pharmacist &&
        renderJobLayoutButtonForWorker()}

      {rolename === roleNameEnum.owner && renderJobLayoutButtonForPharmacy()}
    </div>
  );
};
